import { List } from "immutable";
import { merge } from "lodash";
import { createSelector } from "reselect";

import Dimensions, { scalePixelsToFontSize } from "../../constants/styles/dimensions";
import { immutableRecords } from "../../types";
import sidebarSelectors from "../sidebar/selectors";
import selectorsDesktop from "./selectors.desktop";
import selectorsTablet from "./selectors.tablet";

let BaseSelectors = null;

// #!if iOS === true
// BaseSelectors = selectorsTablet;
// #!else
BaseSelectors = selectorsDesktop;
// #!endif

const getToolbarSplitConstraints = createSelector(
  // inputs
  showAppMenu => showAppMenu,
  // calculate based on inputs
  showAppMenu => {
    const TOOLBAR_HEIGHT = Dimensions.TOOLBAR_HEIGHT;
    if (showAppMenu) {
      return List([
        // App Menu
        immutableRecords.SplitConstraintsRecord({
          minSize: Dimensions.APP_TITLE_BAR_HEIGHT,
          maxSize: Dimensions.APP_TITLE_BAR_HEIGHT,
          preferredSize: Dimensions.APP_TITLE_BAR_HEIGHT
        }),
        // Toolbar
        //#!if harvard !== true && iOS !== true
// immutableRecords.SplitConstraintsRecord({
// minSize: TOOLBAR_HEIGHT,
// maxSize: TOOLBAR_HEIGHT,
// preferredSize: TOOLBAR_HEIGHT
// }),
        //#!elseif harvard !== true && iOS === true
// immutableRecords.SplitConstraintsRecord({
// minSize: Dimensions.TOOLBAR_HEIGHT,
// maxSize: Dimensions.TOOLBAR_HEIGHT,
// preferredSize: Dimensions.TOOLBAR_HEIGHT
// }),
        //#!endif
        // Everything else
        immutableRecords.SplitConstraintsRecord({
          minSize: 200
        })
      ]);
    } else {
      return List([
        // Toolbar
        //#!if harvard !== true && iOS !== true
// immutableRecords.SplitConstraintsRecord({
// minSize: TOOLBAR_HEIGHT,
// maxSize: TOOLBAR_HEIGHT,
// preferredSize: TOOLBAR_HEIGHT
// }),
        //#!elseif harvard !== true && iOS === true
// immutableRecords.SplitConstraintsRecord({
// minSize: Dimensions.TOOLBAR_HEIGHT,
// maxSize: Dimensions.TOOLBAR_HEIGHT,
// preferredSize: Dimensions.TOOLBAR_HEIGHT
// }),
        //#!endif
        // Everything else
        immutableRecords.SplitConstraintsRecord({
          minSize: 200
        })
      ]);
    }
  }
);

const getSidebarConstraints = createSelector(sidebarSelectors.getSidebarWidth, sidebarWidth =>
  immutableRecords.SplitConstraintsRecord({
    minSize: sidebarWidth,
    maxSize: sidebarWidth,
    preferredSize: sidebarWidth
  })
);

const notificationConstraints = immutableRecords.SplitConstraintsRecord({
  minSize: 200,
  canResize: false,
  canCollapse: false
});

const getDesktopSidebarSplitConstraints = createSelector(getSidebarConstraints, sidebarConstraints => {
  return List([
    // Sidebar
    sidebarConstraints,
    // NotificationSplit
    notificationConstraints
  ]);
});

const getTabletSidebarSplitConstraints = createSelector(getSidebarConstraints, sidebarConstraints => {
  return List([
    // NotificationSplit
    notificationConstraints,
    // Sidebar
    sidebarConstraints
  ]);
});

const getWorkspaceFooterConstraints = createSelector(
  // inputs
  globalFontSize => globalFontSize,
  // calculate based on inputs
  globalFontSize => {
    const SCALED_FOOTER_HEIGHT = globalFontSize
      ? scalePixelsToFontSize(Dimensions.FOOTER_HEIGHT, globalFontSize)
      : Dimensions.FOOTER_HEIGHT;
    return List([
      // Main Workspace
      immutableRecords.SplitConstraintsRecord({
        minSize: 100
      }),
      // Footer
      immutableRecords.SplitConstraintsRecord({
        minSize: SCALED_FOOTER_HEIGHT,
        maxSize: SCALED_FOOTER_HEIGHT,
        preferredSize: SCALED_FOOTER_HEIGHT
      })
    ]);
  }
);

const getHarvardMobileToolbarSplitConstraints = () => {
  const SCALED_TOOLBAR_HEIGHT = Dimensions.TOOLBAR_HEIGHT;
  return List([
    // Toolbar
    immutableRecords.SplitConstraintsRecord({
      minSize: SCALED_TOOLBAR_HEIGHT,
      maxSize: SCALED_TOOLBAR_HEIGHT,
      preferredSize: SCALED_TOOLBAR_HEIGHT
    }),
    // Everything else
    immutableRecords.SplitConstraintsRecord({
      minSize: 200
    })
  ]);
};

const getProjectId = state => state.projectId;

export default merge(
  {
    getWorkspaceFooterConstraints,
    getToolbarSplitConstraints,
    getDesktopSidebarSplitConstraints,
    getTabletSidebarSplitConstraints,
    getProjectId,
    getHarvardMobileToolbarSplitConstraints
  },
  BaseSelectors
);
